export default "__VITE_ASSET__BI836E05__"